// Cluster items by route prefix and tile into a clean grid. Each
// cluster (e.g. `/admin/*`) gets its own block; clusters lay out in
// rows of 4 cluster-columns. Items inside a cluster tile in 4 columns.

const ITEM_W = 1722
const ITEM_GAP = 256
const CLUSTER_GAP = 640
const ITEMS_PER_ROW = 4

function clusterKey(pageKey) {
  if (!pageKey) return ''
  // `/admin/users` → `/admin`; `/dashboard` → `/dashboard`; non-routes use `'_components'`.
  if (!pageKey.startsWith('/')) return '_components'
  const parts = pageKey.split('/').filter(Boolean)
  return parts.length > 1 ? '/' + parts[0] : pageKey
}

export function autoLayout() {
  const v2 = this.call('getCanvasV2'); if (!v2) return
  const entries = Object.entries(v2.items || {})
  if (!entries.length) return

  // Bucket by cluster key, sorted alphabetically within each.
  const buckets = new Map()
  for (const [key, it] of entries) {
    const ck = clusterKey(it.pageKey || key)
    if (!buckets.has(ck)) buckets.set(ck, [])
    buckets.get(ck).push([key, it])
  }
  for (const arr of buckets.values()) arr.sort((a, b) => a[0].localeCompare(b[0]))

  // Lay clusters out left-to-right; wrap to a new cluster-row when the
  // running width exceeds a sensible page width (~6 items wide).
  const clusterKeys = Array.from(buckets.keys()).sort()
  let cursorX = 0
  let cursorY = 0
  let rowMaxH = 0
  const ROW_WRAP_X = 4 * (ITEM_W + ITEM_GAP) * 2 // ~8 items wide before wrap

  for (const ck of clusterKeys) {
    const arr = buckets.get(ck)
    const cols = Math.min(ITEMS_PER_ROW, arr.length)
    const rows = Math.ceil(arr.length / ITEMS_PER_ROW)
    const blockW = cols * ITEM_W + (cols - 1) * ITEM_GAP
    const blockH = rows * ITEM_W + (rows - 1) * ITEM_GAP

    if (cursorX > 0 && cursorX + blockW > ROW_WRAP_X) {
      cursorX = 0
      cursorY += rowMaxH + CLUSTER_GAP
      rowMaxH = 0
    }

    arr.forEach(([key], i) => {
      const col = i % ITEMS_PER_ROW
      const row = Math.floor(i / ITEMS_PER_ROW)
      const it = v2.items[key]
      it.x = cursorX + col * (ITEM_W + ITEM_GAP)
      it.y = cursorY + row * (ITEM_W + ITEM_GAP)
      it.w = ITEM_W
      it.h = ITEM_W
      // Imperative DOM update for the item so the change is visible
      // without forcing a children re-render.
      const node = document.querySelector(`[data-canvas-item="${CSS.escape(key)}"]`)
      if (node) {
        node.style.left = it.x + 'px'
        node.style.top = it.y + 'px'
        node.style.width = it.w + 'px'
        node.style.height = it.h + 'px'
      }
    })

    cursorX += blockW + CLUSTER_GAP
    if (blockH > rowMaxH) rowMaxH = blockH
  }

  // Refresh chrome + persist + frame the result.
  this.call('refreshCanvasChrome')
  this.call('pushHistory')
  this.call('persistCanvasLayout')
  // Select all, fit to selection, then clear.
  const allKeys = Object.keys(v2.items)
  this.call('selectMany', allKeys)
  this.call('fitToSelection')
  this.call('clearSelection')
}
